import { Component } from '@angular/core';

@Component({
  selector: 'hs-rvb-methodology',
  standalone: true,
  template: `
    <div class="method">
      <div class="method__title">How this calculator works</div>
      <div class="method__grid">
        <div class="method__item">
          Buy net cost = total cash out (down payment + closing + all monthly payments) minus
          equity recovered at sale (home value less remaining mortgage and selling costs).
        </div>
        <div class="method__item">
          Rent net cost = total rent and renter's insurance paid minus the investment portfolio
          value (down payment + closing costs invested, plus monthly savings if renting is cheaper).
        </div>
        <div class="method__item">
          Opportunity cost: the down payment and closing costs are assumed invested at the market
          return rate, compounding monthly, for the full horizon.
        </div>
        <div class="method__item">
          Mortgage interest deduction is estimated at your marginal tax bracket applied to interest
          paid and property taxes — a simplified approximation; consult a tax advisor.
        </div>
      </div>
    </div>
  `,
  styleUrl: './rvb-methodology.component.scss',
})
export class RvbMethodologyComponent {}
